/**
 * S-06 · Query del export de Trabajos (tanda EMT-CNV-2026-01).
 *
 * Se arma con los MISMOS filtros del listado: lo que el dueño ve en pantalla es
 * lo que se lleva al Excel. Vive aparte del cliente de API para poder probarlo
 * sin red.
 *
 * Un `false` no se manda: acá "sin filtro" y "filtro apagado" son lo mismo, y
 * mandar `vencidos=false` haría que el server lo interprete como un filtro
 * activo distinto del que muestra la pantalla.
 */
export function jobsExportQuery(params: Record<string, unknown>): string {
  const q = new URLSearchParams();
  for (const [clave, valor] of Object.entries(params)) {
    if (valor === undefined || valor === null || valor === '' || valor === false) continue;
    q.set(clave, String(valor));
  }
  return q.toString();
}
